export const DIST_INVOICED_ON =
`<p class="fs-13">Los rendimientos de los proyectos de propiedad en operación que se generen, los recibirás después de impuestos.</p>
<p class="fs-13">Aplican términos y condiciones.</p>
`;

export const DIST_INVOICED_OFF =
`<p class="fs-14">Los rendimientos de los proyectos los recibirás sin retención alguna.</p>
<p class="fs-14">Los primeros 15 días del siguiente mes, se cargarán tus rendimientos brutos.</p>
<p class="fs-14">Puedes apagar y prender el botón siempre que desees, recordando que del 1 al 15 del siguiente mes la opción de apagar o prender se encontrará inactiva, esto quiere decir que si deseas apagar o prender el botón lo podrás realizar del 16 al 30 de cada mes en curso.</p>`;


